import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";

function CustomDropdown({ itemsList, title, handleLogout, ...rest }) {
  const { t } = useTranslation();
  return (
    <DropdownWrapper {...rest}>
      <DropdownButton
        id="dropdown-basic-button"
        title={title}
        className="custom-dropdown"
      >
        {itemsList &&
          itemsList.length > 0 &&
          itemsList.map((item, key) =>
            t(item.label) === t("Logout") ? (
              <Dropdown.Item key={key} onClick={handleLogout}>
                {item.icon && <item.icon className="mx-2" />}
                {t(item.label)}
              </Dropdown.Item>
            ) : (
              <Dropdown.Item as={Link} key={key} to={item.path}>
                {item.icon && <item.icon className="mx-2" />}
                {t(item.label)}
              </Dropdown.Item>
            )
          )}
      </DropdownButton>
    </DropdownWrapper>
  );
}

export default CustomDropdown;

const DropdownWrapper = styled.div`
  .custom-dropdown .btn {
    display: flex;
    align-items: center;
    height: ${({ height }) => (height ? height : "40px")};
    padding-top: ${({ paddingY }) => paddingY && `${paddingY}px`}!important;
    padding-bottom: ${({ paddingY }) => paddingY && `${paddingY}px`}!important;
    padding-right: ${({ paddingX }) => paddingX && `${paddingX}px`}!important;
    padding-left: ${({ paddingX }) => paddingX && `${paddingX}px`}!important;
  }
  .custom-dropdown .btn {
    &,
    &.show,
    &:focus-visible,
    &:focus,
    &:hover,
    &:active {
      border: 1px solid var(--themeColorSecondary);
      border-radius: 10px;
      padding: 10px;
      background-color: ${({ bg }) => (bg ? bg : "var(--bg)")};
      color: ${({ color }) => (color ? color : "var(--darkGrey)")};
    }

  }
  .dropdown-toggle::after {
    border-top: .3rem solid var(--themeColorSecondary);
  }
  .custom-dropdown {
    .dropdown-item {
      text-align: start;
      padding: 10px;
    }
    .dropdown-item:not(:last-child) {
      border-bottom: 1px solid var(--border);
    }
  }
  &.notifyDropdown .custom-dropdown .btn:after {
    display: none;
  }
  @media (max-width: 767px) {
    .custom-dropdown .btn {
      padding-left: 10px !important;
      padding-right: 10px !important;
    }
  }
`;
